import {
  Collapse,
  Divider,
  Grid,
  Paper,
  ListItemButton,
  Stack,
  Typography,
  Button
} from '@mui/material';
import {
  KeyboardArrowDownOutlined,
  KeyboardArrowRightOutlined
} from '@mui/icons-material';
import { useState } from 'react';
import { useAppDispatch } from 'src/hooks';
import SideMenuBar from './sub-menu';
import { IAppDrawerNav, toggleListState } from './app-drawer-slice';
import { RouteLink } from 'src/components/analytics/index';
import GenerateIcon from '../../global/GenerateIcon';
import { useNavigate } from 'react-router';
import './app-drawer.scss';
import ChildItem from './child-item';
import Storage from 'src/utils/storage/storage';

export interface Tabs {
  links: { description: string; link: string; pbiUrl: string }[];
}

export interface IListItem {
  itemIndex: number;
  navOption: IAppDrawerNav;
  open: boolean;
  isActive: boolean;
  getActiveItem: any;
}

export default function ListItem({
  itemIndex,
  navOption,
  open,
  isActive,
  getActiveItem
}: Readonly<IListItem>) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClose = () => {
    setAnchorEl(null);
    setOpenModal(false);
  };
  const appDispatch = useAppDispatch();
  const { source: sourceId } = Storage.getSourceId();
  const [isNavItemActive, setIsNavItemActive] = useState(false);

  // eslint-disable-next-line no-return-assign, no-param-reassign
  const handleListToggle = (navOptionData: IAppDrawerNav) => {
    getActiveItem(itemIndex);

    // checking for children length such that leaf node should not get expanded
    const currentRouteUrl = navOptionData.children.length
      ? navOptionData.children[0].parent.route_url
      : navOptionData.parent.route_url;
    // on click of list item navigate to first children
    navigate(currentRouteUrl);
    dispatch(toggleListState(navOptionData));
    // closing the menu after redirecting
    handleClose();
  };

  // color for link
  const linkColor = '#8f8f8f';
  const activeLinkColor = '#000000DE';

  const currentRouteUrl = window.location.pathname;

  return (
    <div key={navOption.parent.name} style={{ width: '100%' }}>
      <div
        style={{
          padding: '8px 16px',
          backgroundColor: isActive ? '#0000a014' : 'transparent'
        }}
        onClick={() => handleListToggle(navOption)}
        onMouseEnter={(event) => {
          if (anchorEl !== event.currentTarget && navOption.children.length) {
            setAnchorEl(event.currentTarget);
            setOpenModal(true);
          }
        }}
        onMouseLeave={() => {
          setOpenModal(false);
          setAnchorEl(null);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            handleListToggle(navOption);
          }
        }}
        tabIndex={0}
      >
        <Grid container justifyContent='start'>
          <Grid
            item
            xs='auto'
            aria-owns={anchorEl ? 'simple-menu' : undefined}
            aria-haspopup='false'
          >
            {GenerateIcon(navOption.parent.icon)}
          </Grid>
          <Grid ml={1} item xs hidden={!open}>
            <Typography sx={{ fontWeight: 400 }} variant='body1'>
              {navOption.parent.alias}
            </Typography>
          </Grid>
          <Grid hidden={!open} item xs='auto'>
            {navOption.isOpen && navOption.children.length ? (
              <KeyboardArrowDownOutlined />
            ) : (
              ''
            )}
            {!navOption.isOpen && navOption.children.length ? (
              <KeyboardArrowRightOutlined />
            ) : (
              ''
            )}
          </Grid>
        </Grid>
        {openModal && !open && (
          <SideMenuBar
            openModal={openModal}
            menuParent={navOption.parent.alias}
            menus={navOption.children}
            anchorEl={anchorEl}
            handleClose={handleClose}
            itemIndex={itemIndex}
            getActiveItem={getActiveItem}
          />
        )}
      </div>
      {/* adding collapsible menu only for those who has childrens */}
      {open && navOption.children.length ? (
        <Grid
          container
          justifyContent='start'
          sx={{ backgroundColor: '#ebebeb' }}
        >
          <Grid ml={3} item xs>
            <Collapse in={navOption.isOpen}>
              <Grid item xs={12}>
                <Stack spacing={1} padding={1}>
                  {navOption.children
                    .filter((child) => child.parent.is_visible)
                    .map((tab) => {
                      if (tab.children.length) {
                        return (
                          <Paper
                            className='nav-links-container'
                            key={tab.parent.name}
                            elevation={0}
                          >
                            <Typography
                              style={{ fontWeight: '400' }}
                              margin={1}
                              variant='body1'
                              color={linkColor}
                            >
                              {tab.parent.alias}
                            </Typography>
                            <Divider />
                            <Stack padding={1} spacing={1}>
                              {tab.children
                                .filter((child) => child.parent.is_visible)
                                .map((link) => (
                                  <ChildItem
                                    childObj={link}
                                    currentRouteUrl={currentRouteUrl}
                                    activeLinkColor={activeLinkColor}
                                    linkColor={linkColor}
                                  />
                                ))}
                            </Stack>
                          </Paper>
                        );
                      }
                      return (
                        <ChildItem
                          childObj={tab}
                          currentRouteUrl={currentRouteUrl}
                          activeLinkColor={activeLinkColor}
                          linkColor={linkColor}
                        />
                      );
                    })}
                </Stack>
              </Grid>
            </Collapse>
          </Grid>
        </Grid>
      ) : (
        ''
      )}
    </div>
  );
}
